// import "./clear-localstorage";
import "./helpers";
import "./mixins";
import "./firebase";
import "./API";
import "./Styled";
import $ from "jquery";
window.jQuery = window.$ = $;
import "../lib/imagefilters";
//window.ImageFilters = ImageFilters;
